<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {
            value: [String, Number, Array],
            label: String,
            labelWidth: String,
            field: String,
            disabled: {
                type: Boolean,
                default: false,
            },
            add: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            filterable: {
                type: Boolean,
                default: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            isNull:{
                type: Boolean,
                default: true,
            },


            category: [String, Number],
        },
        data() {
            return {
                val: ''
            }
        },
        methods: {
            ...mapActions('dictionaries/paymentType/select', {
                get: 'get',
            }),
            change_value(v) {
                this.$emit('input', v);
                this.$emit('change', v);
                if (this.field) {
                    this.$emit('change-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            input_value(v) {
                this.$emit('input', v);
                if (this.field) {
                    this.$emit('input-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            item_add() {
//                this.$dialog('dictionaries_cash_item', {})
            },
        },
        computed: {
            ...mapGetters('dictionaries/paymentType/select', {
                items: 'filter'
            }),
            append() {
                return this.show_add || this.show_remove;
            },
            show_add() {
                if (this.disabled) return false;
                return this.add;
            },
            show_remove() {
                if (this.disabled) return false;
                if (!this.multiple) return false;
                if (this.value && !this.value.length) {
                    return false;
                }
                return true;
            },
            list() {
                let data = {};
                if (this.category) data.category = this.category;
                return this.items(data);
            },
        },
        watch: {
        },
        mounted() {
            this.get();
        },

        components: {},
    }
</script>
<template>
    <form-group class="dictionary dictionary-payment-type" :label-width="labelWidth" :append="append" :label="label">
        <el-select
                :value="value"
                @change="change_value"
                @input="input_value"
                :disabled="disabled"
                :filterable="filterable"
                :multiple="multiple"
                :collapse-tags="multiple"
                :clearable="clearable">
            <el-option v-if="isNull" :value="0" label="Выбрать">
            </el-option>
            <el-option v-for="item in list"
                       :value="item.value"
                       :label="item.label"
                       :key="item.value">
            </el-option>
        </el-select>
        <el-button
                v-if="show_remove"
                slot="append"
                icon="el-icon-close"
                title="Очистить"
                @click="change_value([])">
        </el-button>
        <el-button
                v-if="show_add"
                slot="append"
                icon="el-icon-plus"
                title="Добавить"
                @click="item_add">
        </el-button>
    </form-group>
</template>
